import { HBarList } from "@/shared/charts/HBarList";
import { foizMatn } from "../utils/davomatDarajasi";

export interface BarListItem {
	id: string;
	name: string;
	/** ⚠️ `null` — rejadagi smena YO'Q. «0%» EMAS: pastga qarang. */
	foiz: number | null;
	/**
	 * Berilsa — qator bosiladigan bo'ladi (masalan bo'lim profiliga
	 * o'tish). Berilmasa oddiy matn sifatida qoladi (masalan «Bo'limsiz»
	 * qatori — bosish uchun profil yo'q).
	 */
	onClick?: () => void;
}

export interface BarListProps {
	items: BarListItem[];
	/** Berilsa — vertikal maqsad chizig'i shu foizda chiziladi. */
	target?: number;
}

/**
 * Foizli gorizontal bar ro'yxati — `shared/charts/HBarList` moslamasi.
 *
 * ⚠️ **Shkala DOIM 0–100** (`max={100}`).
 *
 * ⚠️ **`foiz === null` da bar UMUMAN chizilmaydi** (`value: 0`) va
 * yorliq «—» bo'ladi. `0%` chizilsa qatorni «eng yomon bo'lim» qilib
 * ko'rsatardi, holbuki bu «bugun bu bo'limda smena yo'q» degani.
 */
export function BarList({ items, target }: BarListProps) {
	return (
		<HBarList
			rows={items.map((item) => ({
				key: item.id,
				label: item.name,
				value: item.foiz === null ? 0 : Math.min(100, Math.max(0, item.foiz)),
				valueText: foizMatn(item.foiz),
				onClick: item.onClick,
			}))}
			max={100}
			target={target}
			empty=""
		/>
	);
}
